module.exports = __webpack_public_path__ + "media/images/mv2_copy_dummy-6c984fceb5e3293189f2deb801ffb6b8.png";